<div class="container-login justify-content-center align-items-center">
  <div class="mx-auto form-login">
    <label class="uk-text-body">Cambiar Contraseña</label>
    <mat-icon
    matSuffix 
    [matMenuTriggerFor]="passwordInfo"
    class="ico-menu-password"
    >info</mat-icon>
    <form
      action=""
      [formGroup]="form"
      class="form-login-input"
      (ngSubmit)="onSubmit()"
    >
      <mat-form-field class="col-12 col-md-6"[ngClass]="{'col-md-12':allWidth}">
        <mat-label>Escriba su contraseña actual</mat-label>
        <input
          matInput
          id="password"
          matInput
          formControlName="password"
          #txtPassword
          [type]="hidePassword ? 'password' : 'text'"
        />
        <mat-icon
          matSuffix
          id="hidePassword"
          class="icon-visibility"
          (click)="hidePassword = !hidePassword"
        >
          {{ hidePassword ? "visibility_off" : "visibility" }}
        </mat-icon>
      </mat-form-field>
      <div formGroupName="password_group">
        <mat-form-field class="col-12 col-md-3"[ngClass]="{'col-md-12':allWidth}">
          <mat-label>Escriba su nueva contraseña</mat-label>
          <input
            matInput
            id="passwordNew"
            matInput
            formControlName="newPassword"
            #passwordNew
            [type]="hideNewPassword ? 'password' : 'text'"
          />
          <mat-icon
            matSuffix
            id="hideNewPassword"
            class="icon-visibility"
            (click)="hideNewPassword = !hideNewPassword"
          >
            {{ hideNewPassword ? "visibility_off" : "visibility" }}
          </mat-icon>

        </mat-form-field>
        <mat-form-field class="col-12 col-md-3"[ngClass]="{'col-md-12':allWidth}">
          <mat-label>Confirme su contraseña</mat-label>
          <input
            matInput
            id="passwordNewTwo"
            matInput
            formControlName="passwordNewTwo"
            #passwordNewTwo
            [type]="hideNewPasswordTwo ? 'password' : 'text'"
          />
          <mat-icon
            matSuffix
            id="hideNewPasswordTwo"
            class="icon-visibility"
            (click)="hideNewPasswordTwo = !hideNewPasswordTwo"
          >
            {{ hideNewPasswordTwo ? "visibility_off" : "visibility" }}
          </mat-icon>
        </mat-form-field>
      </div>
      <button
        mat-flat-button
        id="submit"
        type="submit"
        [disabled]="form.invalid || isSubmitting"
        class="button-success"
      >
        Guardar contraseña
      </button>
    </form>
  </div>
</div>

<mat-menu #passwordInfo="matMenu">
  <ng-template matMenuContent>
    <button class="h-auto" mat-menu-item>
      <p class="line-h-30 m-0">
        <b>
          Contraseña debe contener:
        </b>
      </p>
      <p class="line-h-30 m-0">
        - Mínimo 11 caracteres
      </p>
      <p class="line-h-30 m-0">
        - Un carácter especial (#,$,%,&,!,,)
      </p>
      <p class="line-h-30 m-0">
        - Un número (0 al 9)
      </p>
      <p class="line-h-30 m-0">
        - Una mayúscula
      </p>
      <p class="line-h-30 m-0">
        - Una minúscula 
      </p>
    </button>
 </ng-template>
</mat-menu>